define.alias("shared/utils/number-helpers/ratio-to-percent", "calendar/utils/number-helpers/ratio-to-percent");